import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../css/entry.css";
import SriyanshCardHeader from "../../components/CardHeader";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import dayjs from "dayjs";
import EncryptService from "../../service/EncryptionService";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import ListHeaderTableComponent from "../../CustomComponant/ListHeaderTables";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";

function COSGEntry() {
  const navigate = useNavigate();
  const { state } = useLocation();

  let poNumberFromList = state.expponumber;
  let billNumberFromList = state.expbillnumber;

  const [returnData, setreturnData] = useState([]);
  const [cosReturnData, setCOSReturnData] = useState([]);
  const [cosReceiptDate, setcosReceiptDate] = useState(null);
  const [billPassingDate, setbillPassingDate] = useState(null);
  const [errors, setErrors] = useState({});

  const today = dayjs();
  //const [error, setError] = useState("");
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const handleClose = () => {
    navigate("../cosglist", { replace: true });
    // console.log(!cosReturnData);
  };

  const InsertPOData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!cosReceiptDate) {
      formErrors.billRdateerror = "Invalid Receiving Date";
    }
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const cosdt = new Date(cosReceiptDate);
      const cosreceiptdt =
        cosdt.getFullYear() +
        "/" +
        parseInt(cosdt.getMonth() + 1) +
        "/" +
        cosdt.getDate();

      const billdt = new Date(billPassingDate);
      const billPassdt =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

      apiClient
        .post("/COSEntry", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList + " ",
          vbillreceivingdate: cosreceiptdt,
          // vbillpassingdate: billPassdt,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          //setError(response.data);
          navigate("../cosglist", { replace: true });
        })
        .catch(function (error) {
          // setsrcData([]);
          alert(error);
        });
    }
  };

  const UpdateBillPassingDate = async (e) => {
    //console.log("dfgd");
    e.preventDefault();
    let formErrors = {};

    if (!billPassingDate) {
      formErrors.billPdateerror = "Invalid PassingDate";
    }
    if (!cosReceiptDate) {
      formErrors.billRdateerror = "Invalid Receiving Date";
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const billdt = new Date(billPassingDate);
      const billPassdt =
        billdt.getFullYear() +
        "/" +
        parseInt(billdt.getMonth() + 1) +
        "/" +
        billdt.getDate();

      apiClient
        .post("/COSUpdate", {
          vponumber: poNumberFromList,
          vbillnumber: billNumberFromList + " ",
          vbillpassingdate: billPassdt,
          ventryuser: uname,
          vip: ip,
        })
        .then(function (response) {
          // setError(response.data);
          navigate("../cosglist", { replace: true });
        })
        .catch(function (error) {
          // setsrcData([]);
          alert(error);
        });
    }
  };

  const getdata = async (e) => {
    apiClient
      .post("/podetailscos", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      })
      .then(function (response) {
        setreturnData(response.data[0]);
        // getCOSGdata();
      })
      .catch(function (error) {
        alert(error);
      });
  };

  const getCOSGdata = async (e) => {
    try {
      const response11 = await apiClient.post("/cosgData_ByBillnumber", {
        uname: uname,
        poNumber: poNumberFromList + " ",
        billnumber: billNumberFromList + " ",
      });
      // Check if response.data exists and is not empty
      if (response11.data && response11.data.length > 0) {
        setCOSReturnData(response11.data);
        setcosReceiptDate(dayjs(response11.data[0].billreceivingdate));
        // Set first element of the data
      } else {
        // Throw an error if no data is found
        // throw new Error("Data not found for the provided bill number");
        // setCOSReturnData([]);
      }
    } catch (error) {
      // Handle and set the error in state
      //setError(error.message);
      ///setCOSReturnData([]); // Optionally clear data if there is an error
    }
  };

  //console.log (cosReturnData);

  useEffect(() => {
    getdata();
    getCOSGdata();
    // cosReturnData && setcosReceiptDate(cosReturnData.billreceivingdate);
  }, []);

  const headers = [
    ["Indent Number", "PO Number", "Consignee"],
    ["Item Name", "Bill Number", "Bill Date"],
    ["Billed Item Qty", "Billed Value", "Paymenttype"],
  ];

  //
  const rows = [
    [returnData.IndentNumber, returnData.ponumber, returnData.POConsignee],
    [returnData.POItemName, returnData.billnumber, returnData.billdate],
    [
      returnData.billitemQty,
      returnData.billitemValue,
      returnData.paymentDesription,
    ],
  ];

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

    return (
    <Box
      className="cosg-entry-page"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        px: { xs: 1, sm: 1.5, md: 2 },
        py: { xs: 1, sm: 1.5 },
        overflowX: "hidden",
      }}
    >
      <Card
        className="cosg-entry-card"
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          overflow: "hidden",
          borderRadius: { xs: 2, md: 3 },
          border: "1px solid #dbe5f1",
          background: "#ffffff",
          boxShadow: "0 8px 28px rgba(13, 71, 161, 0.10)",
        }}
      >
        {/* HEADER */}
        <Box
          className="cosg-entry-header"
          sx={{
            background:
              "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
            color: "#fff",
            px: { xs: 1.5, sm: 2, md: 2.5 },
            py: { xs: 1.4, sm: 1.6 },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.25rem" },
              fontWeight: 700,
              letterSpacing: { xs: 0, md: 0.2 },
              lineHeight: 1.3,
            }}
          >
            Bill/Invoice Receiving and Passing Date Entry
          </Typography>
        </Box>

        <CardContent
          sx={{
            p: { xs: 1, sm: 1.5, md: 2 },
            "&:last-child": {
              pb: { xs: 1.5, sm: 2, md: 2.5 },
            },
          }}
        >
          {/* PO DETAILS */}
          <Accordion
            defaultExpanded
            className="cosg-po-accordion"
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              mb: { xs: 1.5, md: 2 },
              border: "1px solid #dbe5f1",
              borderRadius: "10px !important",
              overflow: "hidden",
              boxShadow: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={
                <ArrowDownwardIcon
                  sx={{
                    color: "#fff",
                    fontSize: { xs: 20, md: 24 },
                  }}
                />
              }
              sx={{
                minHeight: { xs: 48, sm: 52 },
                px: { xs: 1.5, sm: 2 },
                background:
                  "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
                color: "#fff",
                "& .MuiAccordionSummary-content": {
                  my: { xs: 1, sm: 1.2 },
                },
                "&.Mui-expanded": {
                  minHeight: { xs: 48, sm: 52 },
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "0.9rem", sm: "1rem", md: "1.05rem" },
                  fontWeight: 700,
                }}
              >
                PO Details
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                p: { xs: 0.75, sm: 1, md: 1.5 },
                background: "#f8fbff",
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  overflow: "hidden",
                }}
              >
                <ListHeaderTableComponent
                  headers={headers}
                  rows={rows}
                />
              </Box>
            </AccordionDetails>
          </Accordion>

          {/* DATE SECTION */}
          <Box
            className="cosg-date-section"
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
              background: "#ffffff",
              border: "1px solid #dbe5f1",
              borderRadius: 2,
              p: { xs: 1.25, sm: 1.5, md: 2 },
              mb: { xs: 1.5, md: 2 },
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "0.9rem", sm: "0.95rem", md: "1rem" },
                fontWeight: 700,
                color: "#0D47A1",
                mb: { xs: 1.2, sm: 1.5 },
                pl: 1,
                borderLeft: "4px solid #1976D2",
                lineHeight: 1.4,
              }}
            >
              Bill / Invoice Dates
            </Typography>

            <Box
              className="cosg-date-grid"
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: "1fr 1fr",
                },
                gap: { xs: 1.5, sm: 2, md: 2.5 },
                width: "100%",
                minWidth: 0,
              }}
            >
              {/* RECEIVING DATE */}
              <Box
                sx={{
                  minWidth: 0,
                  width: "100%",
                }}
              >
                <DatePickerComponent
                  label="Bill/Invoice Receiving Date"
                  id="cosReceiptDate"
                  value={cosReceiptDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setcosReceiptDate
                    )
                  }
                  error={errors.billRdateerror}
                  maxDate={today}
                  minDate={
                    returnData.billdate
                      ? dayjs(returnData.billdate)
                      : dayjs()
                  }
                  disabled={cosReturnData.length > 0}
                />
              </Box>

              {/* PASSING DATE */}
              <Box
                sx={{
                  minWidth: 0,
                  width: "100%",
                }}
              >
                <DatePickerComponent
                  label="Bill/Invoice Passing Date"
                  id="billPassingDate"
                  value={billPassingDate}
                  onChange={(newDate) =>
                    handleDateChange(
                      newDate,
                      setbillPassingDate
                    )
                  }
                  error={errors.billPdateerror}
                  maxDate={today}
                  minDate={
                    cosReturnData &&
                    cosReturnData.length > 0 &&
                    cosReturnData[0].billreceivingdate
                      ? dayjs(
                          cosReturnData[0].billreceivingdate
                        )
                      : dayjs()
                  }
                  disabled={!(cosReturnData.length > 0)}
                />
              </Box>
            </Box>
          </Box>

          {/* ACTION BUTTONS */}
          <Box
            className="cosg-action-bar"
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(3, 1fr)",
              },
              gap: { xs: 1, sm: 1.5, md: 2 },
              mt: { xs: 1, md: 1.5 },
            }}
          >
            {/* SAVE */}
            <button
              className="cosg-action-btn cosg-save-btn"
              type="button"
              onClick={InsertPOData}
              title="Click for Data Save"
              disabled={cosReturnData.length > 0}
              style={{
                width: "100%",
                minHeight: "42px",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                background:
                  cosReturnData.length > 0
                    ? "#b0bec5"
                    : "linear-gradient(135deg, #1565C0, #1976D2)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor:
                  cosReturnData.length > 0
                    ? "not-allowed"
                    : "pointer",
                boxShadow:
                  cosReturnData.length > 0
                    ? "none"
                    : "0 4px 12px rgba(21, 101, 192, 0.25)",
              }}
            >
              Save Data
            </button>

            {/* PROCEED */}
            <button
              className="cosg-action-btn cosg-proceed-btn"
              type="button"
              onClick={UpdateBillPassingDate}
              title="Click for Data Proceed"
              disabled={!(cosReturnData.length > 0)}
              style={{
                width: "100%",
                minHeight: "42px",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                background:
                  !(cosReturnData.length > 0)
                    ? "#b0bec5"
                    : "linear-gradient(135deg, #0D47A1, #1565C0)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor:
                  !(cosReturnData.length > 0)
                    ? "not-allowed"
                    : "pointer",
                boxShadow:
                  !(cosReturnData.length > 0)
                    ? "none"
                    : "0 4px 12px rgba(13, 71, 161, 0.25)",
              }}
            >
              Proceed Data
            </button>

            {/* CLOSE */}
            <button
              className="cosg-action-btn cosg-close-btn"
              type="button"
              onClick={handleClose}
              title="Close"
              style={{
                width: "100%",
                minHeight: "42px",
                border: "none",
                borderRadius: "8px",
                padding: "10px 16px",
                background:
                  "linear-gradient(135deg, #c62828, #e53935)",
                color: "#fff",
                fontWeight: 700,
                fontSize: "0.9rem",
                cursor: "pointer",
                boxShadow:
                  "0 4px 12px rgba(198, 40, 40, 0.20)",
              }}
            >
              Close
            </button>
          </Box>
        </CardContent>
      </Card>

      {/* RESPONSIVE STYLES */}
      <style>{`
        .cosg-entry-page,
        .cosg-entry-page * {
          box-sizing: border-box;
        }

        .cosg-entry-page {
          overflow-x: hidden;
        }

        .cosg-entry-card {
          overflow: hidden;
        }

        /* Prevent the table from making the complete page wider */
        .cosg-entry-card table {
          width: 100% !important;
          max-width: 100% !important;
          min-width: 0 !important;
          table-layout: fixed !important;
        }

        .cosg-entry-card th,
        .cosg-entry-card td {
          white-space: normal !important;
          overflow-wrap: anywhere !important;
          word-break: break-word !important;
          max-width: 0;
        }

        .cosg-entry-card .MuiAccordion-root {
          width: 100%;
          max-width: 100%;
          min-width: 0;
        }

        .cosg-entry-card .MuiAccordionDetails-root {
          overflow: hidden;
        }

        .cosg-action-btn {
          transition:
            transform 0.18s ease,
            box-shadow 0.18s ease,
            opacity 0.18s ease;
        }

        .cosg-action-btn:not(:disabled):hover {
          transform: translateY(-1px);
        }

        .cosg-action-btn:not(:disabled):active {
          transform: translateY(0);
        }

        .cosg-action-btn:disabled {
          opacity: 0.85;
        }

        @media (max-width: 600px) {
          .cosg-entry-page {
            padding-left: 6px !important;
            padding-right: 6px !important;
          }

          .cosg-entry-card {
            border-radius: 10px !important;
          }

          .cosg-entry-card th,
          .cosg-entry-card td {
            font-size: 0.72rem !important;
            padding: 6px 4px !important;
          }
        }

        @media (max-width: 400px) {
          .cosg-entry-card th,
          .cosg-entry-card td {
            font-size: 0.67rem !important;
            padding: 5px 3px !important;
          }

          .cosg-action-btn {
            min-height: 40px !important;
            font-size: 0.82rem !important;
          }
        }
      `}</style>
    </Box>
  );
}

export default COSGEntry;
